// extracted by mini-css-extract-plugin
module.exports = {"block":"jj1tTa","block__direction":"_1xJcCh"};